import { Autocomplete, type AutocompleteProps, TextField } from '@mui/material';
import { forwardRef } from 'react';
import type { FieldValues, RegisterOptions } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';

type SelectFieldProps<T = unknown> = {
  name: string;
  rules?: RegisterOptions;
  label: string;
} & Omit<AutocompleteProps<T, false, boolean, false>, 'renderInput'>;

/** @deprecated 抽象化せずに Controller & Autocomplete & TextField を各所で利用してください */
export const SelectField = forwardRef<HTMLDivElement, SelectFieldProps>(
  ({ name, label, rules, disabled, ...props }, ref) => {
    const { control } = useFormContext<FieldValues>();
    const { field, formState } = useController({
      name,
      control,
      rules,
    });
    const errorMessage = formState.errors?.[name]?.message
      ? String(formState.errors[name].message)
      : undefined;

    return (
      <Autocomplete
        {...props}
        ref={field.ref}
        value={field.value ?? null}
        onChange={(_, value) => field.onChange(value)}
        onBlur={field.onBlur}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            ref={ref}
            label={label}
            variant="outlined"
            error={!!errorMessage}
            helperText={errorMessage}
            disabled={disabled}
          />
        )}
      />
    );
  },
) as <T>(props: SelectFieldProps<T> & { ref?: React.ForwardedRef<HTMLDivElement> }) => JSX.Element;
